// ─── Evening Luxe V1 ──────────────────────────────────────────
// Dark, opulent black-tie wedding invitation. Black champagne
// palette, Playfair Display headings, dark cinematic hero,
// elegant detail cards, countdown, and gold accents.

export const eveningLuxeV1 = {
  templateId: 'evening-luxe-v1',
  name: 'Evening Luxe',
  description: 'Dark opulent style. Cinematic black-tie elegance with gold accents.',
  category: 'wedding',
  previewColors: ['#111111', '#D4B06A', '#F6F1E8'],
  theme: {
    palette: 'black-champagne',
    fontPair: 'playfair-inter',
    radius: 'soft',
    shadow: 'card',
    overlay: 'none',
  },
  settings: {
    musicEnabled: false,
    countdownEnabled: true,
    rsvpEnabled: true,
    showMapLink: true,
  },
  sections: [
    {
      id: 'hero-1',
      type: 'hero',
      variant: 'hero-dark-cinematic',
      visible: true,
      animation: {
        title: 'stagger-text',
        subtitle: 'fade-in',
        image: 'zoom-soft',
      },
      editableRules: {
        fields: ['introLabel', 'title', 'subtitle', 'dateText', 'backgroundImage', 'ctaText', 'ctaTarget'],
        locked: ['layout', 'spacing', 'typographyScale'],
      },
      data: {
        introLabel: 'Black Tie Celebration',
        title: 'Isabella & Matteo',
        subtitle: 'An evening of elegance, candlelight, and celebration in the city.',
        dateText: '24 October 2026 · 18:30',
        backgroundImage: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=1600&auto=format&fit=crop',
        ctaText: 'View the evening',
        ctaTarget: 'rsvp',
      },
    },
    {
      id: 'details-1',
      type: 'event-details',
      variant: 'details-elegant-columns',
      visible: true,
      animation: { section: 'fade-in', items: 'stagger-cards' },
      editableRules: {
        fields: ['date', 'time', 'venue', 'address', 'note'],
        locked: ['grid', 'iconStyle', 'spacing'],
      },
      data: {
        date: 'Saturday, 24 October 2026',
        time: '18:30',
        venue: 'The Grand Hall',
        address: 'Milan, Italy',
        note: 'Cocktail reception, seated dinner, and dancing to follow.',
      },
    },
    {
      id: 'countdown-1',
      type: 'countdown',
      variant: 'countdown-luxe',
      visible: true,
      animation: { section: 'fade-in' },
      editableRules: {
        fields: ['targetDateTime'],
        locked: ['layout', 'spacing'],
      },
      data: {
        targetDateTime: '2026-10-24T18:30:00',
      },
    },
    {
      id: 'gallery-1',
      type: 'gallery',
      variant: 'gallery-dark-editorial',
      visible: true,
      animation: { items: 'zoom-soft' },
      editableRules: {
        fields: ['images'],
        locked: ['grid', 'gap', 'imageRatio'],
      },
      data: {
        images: [
          'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?q=80&w=900&auto=format&fit=crop',
          'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?q=80&w=900&auto=format&fit=crop',
          'https://images.unsplash.com/photo-1520854221256-17451cc331bf?q=80&w=900&auto=format&fit=crop',
          'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?q=80&w=900&auto=format&fit=crop',
        ],
      },
    },
    {
      id: 'venue-1',
      type: 'venue',
      variant: 'venue-split-luxe',
      visible: true,
      animation: { section: 'fade-up' },
      editableRules: {
        fields: ['venueName', 'address', 'mapLink', 'note', 'image'],
        locked: ['layout', 'spacing', 'buttonStyle'],
      },
      data: {
        venueName: 'The Grand Hall',
        address: 'Milan, Italy',
        note: 'A formal setting with candlelit interiors, sweeping architecture, and an unforgettable atmosphere.',
        mapLink: 'https://maps.google.com',
        image: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?q=80&w=1200&auto=format&fit=crop',
      },
    },
    {
      id: 'rsvp-1',
      type: 'rsvp',
      variant: 'rsvp-luxe-card',
      visible: true,
      animation: { section: 'fade-in' },
      editableRules: {
        fields: ['title', 'description', 'submitLabel'],
        locked: ['validationRules', 'inputStyle', 'spacing'],
      },
      data: {
        title: 'RSVP',
        description: 'Kindly reply by 20 September 2026.',
        submitLabel: 'Send response',
      },
    },
    {
      id: 'footer-1',
      type: 'footer',
      variant: 'footer-centered-luxe',
      visible: true,
      animation: { section: 'fade-in' },
      editableRules: {
        fields: ['closingMessage', 'names'],
        locked: ['layout', 'spacing'],
      },
      data: {
        closingMessage: 'We look forward to sharing this extraordinary evening with you.',
        names: 'Isabella & Matteo',
      },
    },
  ],
};
